import { render } from "./WarehouseId.vue?vue&type=template&id=0763a8f2&scoped=true&ts=true"
import script from "./WarehouseId.vue?vue&type=script&lang=ts"
export * from "./WarehouseId.vue?vue&type=script&lang=ts"

import "./WarehouseId.vue?vue&type=style&index=0&id=0763a8f2&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0763a8f2"]])

export default __exports__